import {
  Component,
  Host,
  Prop,
  Element,
  h,
  Event,
  EventEmitter,
  Watch
} from "@stencil/core";

import SwaggerUI from "swagger-ui-dist/swagger-ui-es-bundle.js";

@Component({
  tag: "gx-ide-launchpad-api",
  styleUrl: "launchpad-api.scss",
  shadow: false,
  assetsDirs: ["gx-ide-assets/launchpad-api"]
})
export class GxIdeLaunchpadApi {
  swaggerContainer!: HTMLElement;

  @Element() el: HTMLElement;

  /**
   * Data for the individual API (url and spec)
   */
  @Prop() readonly data!: ApiData;

  /**
   * Callback function for object selection (passed from parent)
   */
  @Prop() onObjectSelected?: ObjectSelectedCallback;

  /**
   * Event emitted when copying to clipboard
   */
  @Event() copyToClipboard: EventEmitter<{ url: string }>;

  componentDidLoad() {
    this.#renderSwaggerUI();
  }

  @Watch("data")
  onDataChanged() {
    // Only re-render when data actually changes
    this.#renderSwaggerUI();
  }

  /**
   * Handles API click and calls parent callback
   */
  #handleApiClick() {
    if (this.onObjectSelected && this.data.key) {
      // Send the full key object as string in format "type|id"
      const keyString = `${this.data.key.type}|${this.data.key.id}`;
      this.onObjectSelected({ detail: { key: keyString } });
    } else if (this.onObjectSelected && this.data.url) {
      // If no key, use URL as identifier
      this.onObjectSelected({ detail: { key: this.data.url } });
    }
  }

  #renderSwaggerUI() {
    SwaggerUI({
      spec: this.data.spec,
      dom_id: "#swagger-ui",
      domNode: this.swaggerContainer,
      layout: "BaseLayout"
    });
  }

  render() {
    return (
      <Host>
        <div
          id="swagger-ui"
          ref={el => (this.swaggerContainer = el as HTMLElement)}
          onClick={this.#handleApiClick}
          style={{ cursor: "pointer" }}
        ></div>
      </Host>
    );
  }
}

// Interfaces for type safety
interface ApiData {
  readonly url: string;
  readonly key?: {
    type: string;
    id: string;
  };
  readonly spec?: {
    readonly openapi?: string;
    readonly info?: {
      readonly title?: string;
      readonly version?: string;
    };
    readonly servers?: Array<{
      readonly url: string;
    }>;
  };
}

interface ObjectSelectedEvent {
  readonly detail: {
    readonly key: string;
  };
}

type ObjectSelectedCallback = (event: ObjectSelectedEvent) => void;
